// extracted by mini-css-extract-plugin
module.exports = {"root":"az_idb","rounded":"az_jdb","outlined":"az_kdb","elevation0":"az_ldb","elevation1":"az_mdb","elevation2":"az_ndb","elevation6":"az_odb","elevation4":"az_pdb"};